module.exports = __webpack_public_path__ + "static/media/CT_2019_30440A_pdf.a619336b.pdf";